// extracted by mini-css-extract-plugin
module.exports = {"subtitle":"Subtitle_subtitle__eczrb"};